module.exports = __webpack_public_path__ + "img/home-phone.ceb7478b.svg";